module.exports = __webpack_public_path__ + "img/img-cadeau-1.png";